export default class Paging<T> {
    public collection: T[]
    public count: number
    public total: number
    public page: number
    public totalPages: number
}